import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/hierarchyNodes')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/hierarchyNode' })
  },
})
